import { ICountry } from 'types';
import { countryCodes } from './countryCodes.js';

export type CountryDefintion = ICountry & { key: string };

export const recognisedCountries: Record<string, CountryDefintion> = {
  AUSTRALIA: {
    key: 'AUSTRALIA',
    region: 'Oceania',
    countryName: 'Australia',
    transferMate: 14,
    nationality: 'Australian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.AUSTRALIA,
  },
  AUSTRIA: {
    key: 'AUSTRIA',
    region: 'Europe',
    countryName: 'Austria',
    transferMate: 16,
    nationality: 'Austrian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.AUSTRIA,
  },
  BAHRAIN: {
    key: 'BAHRAIN',
    region: 'Middle East',
    countryName: 'Bahrain',
    transferMate: 19,
    nationality: 'Bahraini',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.BAHRAIN,
  },
  BARBADOS: {
    key: 'BARBADOS',
    region: 'North America',
    countryName: 'Barbados',
    transferMate: 21,
    nationality: 'Barbadian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.BARBADOS,
  },
  BELGIUM: {
    key: 'BELGIUM',
    region: 'Europe',
    countryName: 'Belgium',
    transferMate: 23,
    nationality: 'Belgian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.BELGIUM,
  },
  BOTSWANA: {
    key: 'BOTSWANA',
    region: 'Africa',
    countryName: 'Botswana',
    transferMate: 30,
    nationality: 'Motswana',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.BOTSWANA,
  },
  BRAZIL: {
    key: 'BRAZIL',
    region: 'South America',
    countryName: 'Brazil',
    transferMate: 32,
    nationality: 'Brazilian',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.BRAZIL,
  },
  BRUNEI_DARUSSALAM: {
    key: 'BRUNEI_DARUSSALAM',
    region: 'Southeast Asia',
    countryName: 'Brunei Darussalam',
    nationality: 'Bruneian',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.BRUNEI_DARUSSALAM,
  },
  BULGARIA: {
    key: 'BULGARIA',
    region: 'Europe',
    countryName: 'Bulgaria',
    transferMate: 35,
    nationality: 'Bulgarian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.BULGARIA,
  },
  CAMBODIA: {
    key: 'CAMBODIA',
    region: 'Southeast Asia',
    countryName: 'Cambodia',
    transferMate: 38,
    nationality: 'Cambodian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.CAMBODIA,
  },
  CANADA: {
    key: 'CANADA',
    region: 'North America',
    countryName: 'Canada',
    transferMate: 40,
    nationality: 'Canadian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.CANADA,
  },
  CHILE: {
    key: 'CHILE',
    region: 'South America',
    countryName: 'Chile',
    transferMate: 46,
    nationality: 'Chilean',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.CHILE,
  },
  CHINA: {
    key: 'CHINA',
    region: 'East Asia',
    countryName: 'China',
    transferMate: 47,
    nationality: 'Chinese',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.CHINA,
  },
  CROATIA: {
    key: 'CROATIA',
    region: 'Europe',
    countryName: 'Croatia',
    transferMate: 56,
    nationality: 'Croatian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.CROATIA,
  },
  CYPRUS: {
    key: 'CYPRUS',
    region: 'Europe',
    countryName: 'Cyprus',
    transferMate: 58,
    nationality: 'Cypriot',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.CYPRUS,
  },
  CZECH_REPUBLIC: {
    key: 'CZECH_REPUBLIC',
    region: 'Europe',
    countryName: 'Czech Republic',
    transferMate: 60,
    nationality: 'Czech',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.CZECH_REPUBLIC,
  },
  DENMARK: {
    key: 'DENMARK',
    region: 'Europe',
    countryName: 'Denmark',
    transferMate: 61,
    nationality: 'Danish',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.DENMARK,
  },
  DOMINICA: {
    key: 'DOMINICA',
    region: 'North America',
    countryName: 'Dominica',
    transferMate: 64,
    nationality: 'Dominican',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.DOMINICA,
  },
  ESTONIA: {
    key: 'ESTONIA',
    region: 'Europe',
    countryName: 'Estonia',
    transferMate: 72,
    nationality: 'Estonian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.ESTONIA,
  },
  FINLAND: {
    key: 'FINLAND',
    region: 'Europe',
    countryName: 'Finland',
    transferMate: 77,
    nationality: 'Finnish',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.FINLAND,
  },
  FRANCE: {
    key: 'FRANCE',
    region: 'Europe',
    countryName: 'France',
    transferMate: 79,
    nationality: 'French',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.FRANCE,
  },
  GERMANY: {
    key: 'GERMANY',
    region: 'Europe',
    countryName: 'Germany',
    transferMate: 87,
    nationality: 'German',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.GERMANY,
  },
  GREECE: {
    key: 'GREECE',
    region: 'Europe',
    countryName: 'Greece',
    transferMate: 91,
    nationality: 'Greek',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.GREECE,
  },
  HONG_KONG: {
    key: 'HONG_KONG',
    region: 'East Asia',
    countryName: 'Hong Kong',
    nationality: 'Hong Konger',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.HONG_KONG,
  },
  HUNGARY: {
    key: 'HUNGARY',
    region: 'Europe',
    countryName: 'Hungary',
    transferMate: 107,
    nationality: 'Hungarian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.HUNGARY,
  },
  ICELAND: {
    key: 'ICELAND',
    region: 'Non_EU Europe',
    countryName: 'Iceland',
    transferMate: 108,
    nationality: 'Icelander',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.ICELAND,
  },
  INDONESIA: {
    key: 'INDONESIA',
    region: 'Southeast Asia',
    countryName: 'Indonesia',
    transferMate: 110,
    nationality: 'Indonesian',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.INDONESIA,
  },
  IRELAND: {
    key: 'IRELAND',
    region: 'Europe',
    countryName: 'Ireland',
    transferMate: 113,
    nationality: 'Irish',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.IRELAND,
  },
  ITALY: {
    key: 'ITALY',
    region: 'Europe',
    countryName: 'Italy',
    transferMate: 116,
    nationality: 'Italian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.ITALY,
  },
  JAPAN: {
    key: 'JAPAN',
    region: 'East Asia',
    countryName: 'Japan',
    transferMate: 119,
    nationality: 'Japanese',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.JAPAN,
  },
  KAZAKHSTAN: {
    key: 'KAZAKHSTAN',
    region: 'Central Asia (CIS)',
    countryName: 'Kazakhstan',
    transferMate: 122,
    nationality: 'Kazakhstani',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.KAZAKHSTAN,
  },
  SOUTH_KOREA: {
    key: 'SOUTH_KOREA',
    region: 'East Asia',
    countryName: 'South Korea',
    nationality: 'South Korean',
    atas: false,
    tb: true,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.SOUTH_KOREA,
  },
  KUWAIT: {
    key: 'KUWAIT',
    region: 'Middle East',
    countryName: 'Kuwait',
    transferMate: 126,
    nationality: 'Kuwaiti',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.KUWAIT,
  },
  LATVIA: {
    key: 'LATVIA',
    region: 'Europe',
    countryName: 'Latvia',
    transferMate: 129,
    nationality: 'Latvian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.LATVIA,
  },
  LIECHTENSTEIN: {
    key: 'LIECHTENSTEIN',
    region: 'Non_EU Europe',
    countryName: 'Liechtenstein',
    transferMate: 134,
    nationality: 'Liechtensteiner',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.LIECHTENSTEIN,
  },
  LITHUANIA: {
    key: 'LITHUANIA',
    region: 'Europe',
    countryName: 'Lithuania',
    transferMate: 135,
    nationality: 'Lithuanian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.LITHUANIA,
  },
  LUXEMBOURG: {
    key: 'LUXEMBOURG',
    region: 'Europe',
    countryName: 'Luxembourg',
    transferMate: 136,
    nationality: 'Luxembourger',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.LUXEMBOURG,
  },
  MACAU: {
    key: 'MACAU',
    region: 'East Asia',
    countryName: 'Macau',
    nationality: 'Macanese',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.MACAU,
  },
  MALAYSIA: {
    key: 'MALAYSIA',
    region: 'Southeast Asia',
    countryName: 'Malaysia',
    transferMate: 141,
    nationality: 'Malaysian',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.MALAYSIA,
  },
  MALTA: {
    key: 'MALTA',
    region: 'Europe',
    countryName: 'Malta',
    transferMate: 144,
    nationality: 'Maltese',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.MALTA,
  },
  MAURITIUS: {
    key: 'MAURITIUS',
    region: 'Africa',
    countryName: 'Mauritius',
    transferMate: 149,
    nationality: 'Mauritian',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.MAURITIUS,
  },
  MEXICO: {
    key: 'MEXICO',
    region: 'North America',
    countryName: 'Mexico',
    transferMate: 151,
    nationality: 'Mexican',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.MEXICO,
  },
  NETHERLANDS: {
    key: 'NETHERLANDS',
    region: 'Europe',
    countryName: 'Netherlands',
    nationality: 'Dutch',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.NETHERLANDS,
  },
  NEW_ZEALAND: {
    key: 'NEW_ZEALAND',
    region: 'Oceania',
    countryName: 'New Zealand',
    transferMate: 164,
    nationality: 'New Zealander',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.NEW_ZEALAND,
  },
  NORWAY: {
    key: 'NORWAY',
    region: 'Non_EU Europe',
    countryName: 'Norway',
    transferMate: 171,
    nationality: 'Norwegian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.NORWAY,
  },
  OMAN: {
    key: 'OMAN',
    region: 'Middle East',
    countryName: 'Oman',
    transferMate: 172,
    nationality: 'Omani',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.OMAN,
  },
  PERU: {
    key: 'PERU',
    region: 'South America',
    countryName: 'Peru',
    transferMate: 178,
    nationality: 'Peruvian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.PERU,
  },
  POLAND: {
    key: 'POLAND',
    region: 'Europe',
    countryName: 'Poland',
    transferMate: 181,
    nationality: 'Polish',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.POLAND,
  },
  PORTUGAL: {
    key: 'PORTUGAL',
    region: 'Europe',
    countryName: 'Portugal',
    transferMate: 182,
    nationality: 'Portuguese',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.PORTUGAL,
  },
  QATAR: {
    key: 'QATAR',
    region: 'Middle East',
    countryName: 'Qatar',
    transferMate: 184,
    nationality: 'Qatari',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.QATAR,
  },
  ROMANIA: {
    key: 'ROMANIA',
    region: 'Europe',
    countryName: 'Romania',
    transferMate: 186,
    nationality: 'Romanian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.ROMANIA,
  },
  SINGAPORE: {
    key: 'SINGAPORE',
    region: 'Southeast Asia',
    countryName: 'Singapore',
    transferMate: 203,
    nationality: 'Singaporean',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.SINGAPORE,
  },
  SLOVAKIA: {
    key: 'SLOVAKIA',
    region: 'Europe',
    countryName: 'Slovakia',
    transferMate: 204,
    nationality: 'Slovakian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.SLOVAKIA,
  },
  SLOVENIA: {
    key: 'SLOVENIA',
    region: 'Europe',
    countryName: 'Slovenia',
    transferMate: 205,
    nationality: 'Slovenian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.SLOVENIA,
  },
  SPAIN: {
    key: 'SPAIN',
    region: 'Europe',
    countryName: 'Spain',
    transferMate: 211,
    nationality: 'Spanish',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.SPAIN,
  },
  SWEDEN: {
    key: 'SWEDEN',
    region: 'Europe',
    countryName: 'Sweden',
    transferMate: 217,
    nationality: 'Swedish',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.SWEDEN,
  },
  SWITZERLAND: {
    key: 'SWITZERLAND',
    region: 'Non_EU Europe',
    countryName: 'Switzerland',
    transferMate: 218,
    nationality: 'Swiss',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'EUSS',
    categoryNewNameRefactor: 'EUSS',
    ...countryCodes.SWITZERLAND,
  },
  TAIWAN: {
    key: 'TAIWAN',
    region: 'East Asia',
    countryName: 'Taiwan',
    transferMate: 220,
    nationality: 'Taiwanese',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.TAIWAN,
  },
  THAILAND: {
    key: 'THAILAND',
    region: 'Southeast Asia',
    countryName: 'Thailand',
    transferMate: 223,
    nationality: 'Thai',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.THAILAND,
  },
  TUNISIA: {
    key: 'TUNISIA',
    region: 'Africa',
    countryName: 'Tunisia',
    transferMate: 228,
    nationality: 'Tunisian',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.TUNISIA,
  },
  UNITED_ARAB_EMIRATES: {
    key: 'UNITED_ARAB_EMIRATES',
    region: 'Middle East',
    countryName: 'United Arab Emirates',
    transferMate: 235,
    nationality: 'Emirati',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.UNITED_ARAB_EMIRATES,
  },
  UNITED_STATES_OF_AMERICA: {
    key: 'UNITED_STATES_OF_AMERICA',
    region: 'North America',
    countryName: 'United States of America',
    nationality: 'American',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.UNITED_STATES_OF_AMERICA,
  },
  SERBIA: {
    key: 'SERBIA',
    region: 'Non_EU Europe',
    countryName: 'Serbia',
    transferMate: 200,
    nationality: 'Serbian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.SERBIA,
  },
  AFGHANISTAN: {
    key: 'AFGHANISTAN',
    region: 'Middle East',
    countryName: 'Afghanistan',
    transferMate: 2,
    nationality: 'Afghan',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.AFGHANISTAN,
  },
  ALBANIA: {
    key: 'ALBANIA',
    region: 'Non_EU Europe',
    countryName: 'Albania',
    transferMate: 3,
    nationality: 'Albanian',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ALBANIA,
  },
  ALGERIA: {
    key: 'ALGERIA',
    region: 'Africa',
    countryName: 'Algeria',
    transferMate: 4,
    nationality: 'Algerian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ALGERIA,
  },
  AMERICAN_SAMOA: {
    key: 'AMERICAN_SAMOA',
    region: 'Oceania',
    countryName: 'American Samoa',
    transferMate: 5,
    nationality: 'Samoan (American)',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.AMERICAN_SAMOA,
  },
  ANDORRA: {
    key: 'ANDORRA',
    region: 'Europe',
    countryName: 'Andorra',
    transferMate: 6,
    nationality: 'Andorran',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ANDORRA,
  },
  ANGOLA: {
    key: 'ANGOLA',
    region: 'Africa',
    countryName: 'Angola',
    transferMate: 7,
    nationality: 'Angolan',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ANGOLA,
  },
  ANGUILLA: {
    key: 'ANGUILLA',
    region: 'North America',
    countryName: 'Anguilla',
    transferMate: 8,
    nationality: 'Anguillan',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ANGUILLA,
  },
  ANTARCTICA: {
    key: 'ANTARCTICA',
    region: 'Antarctica',
    countryName: 'Antarctica',
    transferMate: 9,
    nationality: 'Antarctic',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ANTARCTICA,
  },
  ANTIGUA_AND_BARBUDA: {
    key: 'ANTIGUA_AND_BARBUDA',
    region: 'North America',
    countryName: 'Antigua and Barbuda',
    transferMate: 10,
    nationality: 'Antiguans',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ANTIGUA_AND_BARBUDA,
  },
  ARGENTINA: {
    key: 'ARGENTINA',
    region: 'South America',
    countryName: 'Argentina',
    transferMate: 11,
    nationality: 'Argentinean',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ARGENTINA,
  },
  ARMENIA: {
    key: 'ARMENIA',
    region: 'Central Asia (CIS)',
    countryName: 'Armenia',
    transferMate: 12,
    nationality: 'Armenian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ARMENIA,
  },
  ARUBA: {
    key: 'ARUBA',
    region: 'South America',
    countryName: 'Aruba',
    transferMate: 13,
    nationality: 'Arubian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ARUBA,
  },
  AZERBAIJAN: {
    key: 'AZERBAIJAN',
    region: 'Central Asia (CIS)',
    countryName: 'Azerbaijan',
    transferMate: 17,
    nationality: 'Azerbaijani',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.AZERBAIJAN,
  },
  BAHAMAS: {
    key: 'BAHAMAS',
    region: 'North America',
    countryName: 'Bahamas',
    transferMate: 18,
    nationality: 'Bahamian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BAHAMAS,
  },
  BANGLADESH: {
    key: 'BANGLADESH',
    region: 'South Asia',
    countryName: 'Bangladesh',
    transferMate: 20,
    nationality: 'Bangladeshi',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BANGLADESH,
  },
  BELARUS: {
    key: 'BELARUS',
    region: 'Non_EU Europe|Central Asia (CIS)',
    countryName: 'Belarus',
    transferMate: 22,
    nationality: 'Belarusian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BELARUS,
  },
  BELIZE: {
    key: 'BELIZE',
    region: 'North America',
    countryName: 'Belize',
    transferMate: 24,
    nationality: 'Belizean',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BELIZE,
  },
  BENIN: {
    key: 'BENIN',
    region: 'Africa',
    countryName: 'Benin',
    transferMate: 25,
    nationality: 'Beninese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BENIN,
  },
  BERMUDA: {
    key: 'BERMUDA',
    region: 'North America',
    countryName: 'Bermuda',
    transferMate: 26,
    nationality: 'Bermudan',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BERMUDA,
  },
  BHUTAN: {
    key: 'BHUTAN',
    region: 'South Asia',
    countryName: 'Bhutan',
    transferMate: 27,
    nationality: 'Bhutanese',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BHUTAN,
  },
  BOLIVIA: {
    key: 'BOLIVIA',
    region: 'South America',
    countryName: 'Bolivia',
    transferMate: 28,
    nationality: 'Bolivian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BOLIVIA,
  },
  BOSNIA_AND_HERZEGOVINA: {
    key: 'BOSNIA_AND_HERZEGOVINA',
    region: 'Non_EU Europe',
    countryName: 'Bosnia and Herzegovina',
    transferMate: 29,
    nationality: 'Bosnian',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BOSNIA_AND_HERZEGOVINA,
  },
  BOUVET_ISLAND: {
    key: 'BOUVET_ISLAND',
    region: 'South America',
    countryName: 'Bouvet Island',
    transferMate: 31,
    nationality: 'Bouvet Island',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BOUVET_ISLAND,
  },
  BRITISH_INDIAN_OCEAN_TERRITORY: {
    key: 'BRITISH_INDIAN_OCEAN_TERRITORY',
    region: 'South Asia',
    countryName: 'British Indian Ocean Territory',
    transferMate: 33,
    nationality: 'British (IOT)',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY,
  },
  BURKINA_FASO: {
    key: 'BURKINA_FASO',
    region: 'Africa',
    countryName: 'Burkina Faso',
    transferMate: 36,
    nationality: 'Burkinabe',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BURKINA_FASO,
  },
  BURUNDI: {
    key: 'BURUNDI',
    region: 'Africa',
    countryName: 'Burundi',
    transferMate: 37,
    nationality: 'Burundian',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BURUNDI,
  },
  CAMEROON: {
    key: 'CAMEROON',
    region: 'Africa',
    countryName: 'Cameroon',
    transferMate: 39,
    nationality: 'Cameroonian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CAMEROON,
  },
  CAPE_VERDE: {
    key: 'CAPE_VERDE',
    region: 'Africa',
    countryName: 'Cape Verde',
    transferMate: 42,
    nationality: 'Cape Verdean',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CAPE_VERDE,
  },
  CAYMAN_ISLANDS: {
    key: 'CAYMAN_ISLANDS',
    region: 'North America',
    countryName: 'Cayman Islands',
    transferMate: 43,
    nationality: 'Caymanian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CAYMAN_ISLANDS,
  },
  CENTRAL_AFRICAN_REPUBLIC: {
    key: 'CENTRAL_AFRICAN_REPUBLIC',
    region: 'Africa',
    countryName: 'Central African Republic',
    transferMate: 44,
    nationality: 'Central African',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CENTRAL_AFRICAN_REPUBLIC,
  },
  CHAD: {
    key: 'CHAD',
    region: 'Africa',
    countryName: 'Chad',
    transferMate: 45,
    nationality: 'Chadian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CHAD,
  },
  CHRISTMAS_ISLAND: {
    key: 'CHRISTMAS_ISLAND',
    region: 'Southeast Asia',
    countryName: 'Christmas Island',
    transferMate: 48,
    nationality: 'Christmas Islander',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CHRISTMAS_ISLAND,
  },
  COCOS_KEELING_ISLANDS: {
    key: 'COCOS_KEELING_ISLANDS',
    region: 'Southeast Asia',
    countryName: 'Cocos (Keeling) Islands',
    transferMate: 49,
    nationality: 'Cocossian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.COCOS_KEELING_ISLANDS,
  },
  COLOMBIA: {
    key: 'COLOMBIA',
    region: 'South America',
    countryName: 'Colombia',
    transferMate: 50,
    nationality: 'Colombian',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.COLOMBIA,
  },
  COMOROS: {
    key: 'COMOROS',
    region: 'Africa',
    countryName: 'Comoros',
    transferMate: 51,
    nationality: 'Comoran',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.COMOROS,
  },
  CONGO: {
    key: 'CONGO',
    region: 'Africa',
    countryName: 'Congo',
    transferMate: 52,
    nationality: 'Congolese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CONGO,
  },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: {
    key: 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE',
    region: 'Africa',
    transferMate: 256,
    countryName: 'Congo, the Democratic Republic of the',
    nationality: 'Congolese (DRC)',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  },
  COOK_ISLANDS: {
    key: 'COOK_ISLANDS',
    region: 'Oceania',
    countryName: 'Cook Islands',
    transferMate: 53,
    nationality: 'Cook Islander',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.COOK_ISLANDS,
  },
  COSTA_RICA: {
    key: 'COSTA_RICA',
    region: 'North America',
    countryName: 'Costa Rica',
    transferMate: 54,
    nationality: 'Costa Rican',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.COSTA_RICA,
  },
  COTE_DIVOIRE: {
    key: 'COTE_DIVOIRE',
    region: 'Africa',
    countryName: "Cote D'Ivoire",
    nationality: 'Ivorian',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.COTE_DIVOIRE,
  },
  CUBA: {
    key: 'CUBA',
    region: 'North America',
    countryName: 'Cuba',
    transferMate: 57,
    nationality: 'Cuban',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CUBA,
  },
  DJIBOUTI: {
    key: 'DJIBOUTI',
    region: 'Africa',
    countryName: 'Djibouti',
    transferMate: 63,
    nationality: 'Djiboutian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.DJIBOUTI,
  },
  DOMINICAN_REPUBLIC: {
    key: 'DOMINICAN_REPUBLIC',
    region: 'North America',
    countryName: 'Dominican Republic',
    transferMate: 65,
    nationality: 'Dominican (Republic)',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'AppendixH',
    categoryNewNameRefactor: 'Differential (Low Risk)',
    ...countryCodes.DOMINICAN_REPUBLIC,
  },
  ECUADOR: {
    key: 'ECUADOR',
    region: 'South America',
    countryName: 'Ecuador',
    transferMate: 67,
    nationality: 'Ecuadorean',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ECUADOR,
  },
  EGYPT: {
    key: 'EGYPT',
    region: 'Middle East|Africa',
    countryName: 'Egypt',
    transferMate: 68,
    nationality: 'Egyptian',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.EGYPT,
  },
  EL_SALVADOR: {
    key: 'EL_SALVADOR',
    region: 'North America',
    countryName: 'El Salvador',
    transferMate: 69,
    nationality: 'Salvadorean',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.EL_SALVADOR,
  },
  EQUATORIAL_GUINEA: {
    key: 'EQUATORIAL_GUINEA',
    region: 'Africa',
    countryName: 'Equatorial Guinea',
    transferMate: 70,
    nationality: 'Equatorial Guinean',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.EQUATORIAL_GUINEA,
  },
  ERITREA: {
    key: 'ERITREA',
    region: 'Africa',
    countryName: 'Eritrea',
    transferMate: 71,
    nationality: 'Eritrean',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ERITREA,
  },
  ETHIOPIA: {
    key: 'ETHIOPIA',
    region: 'Africa',
    countryName: 'Ethiopia',
    transferMate: 73,
    nationality: 'Ethiopian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ETHIOPIA,
  },
  FALKLAND_ISLANDS_MALVINAS: {
    key: 'FALKLAND_ISLANDS_MALVINAS',
    region: 'South America',
    countryName: 'Falkland Islands (Malvinas)',
    nationality: 'Falkland Islander',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.FALKLAND_ISLANDS_MALVINAS,
  },
  FAROE_ISLANDS: {
    key: 'FAROE_ISLANDS',
    region: 'Europe',
    countryName: 'Faroe Islands',
    transferMate: 75,
    nationality: 'Faroese',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.FAROE_ISLANDS,
  },
  FIJI: {
    key: 'FIJI',
    region: 'Oceania',
    countryName: 'Fiji',
    nationality: 'Fijian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.FIJI,
  },
  FRENCH_GUIANA: {
    key: 'FRENCH_GUIANA',
    region: 'South America',
    countryName: 'French Guiana',
    transferMate: 81,
    nationality: 'French Guianese',
    atas: false,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.FRENCH_GUIANA,
  },
  FRENCH_POLYNESIA: {
    key: 'FRENCH_POLYNESIA',
    region: 'Oceania',
    countryName: 'French Polynesia',
    transferMate: 82,
    nationality: 'French Polynesian',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.FRENCH_POLYNESIA,
  },
  FRENCH_SOUTHERN_TERRITORIES: {
    key: 'FRENCH_SOUTHERN_TERRITORIES',
    region: 'South Asia',
    countryName: 'French Southern Territories',
    transferMate: 83,
    nationality: 'French (Southern Territories)',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.FRENCH_SOUTHERN_TERRITORIES,
  },
  GABON: {
    key: 'GABON',
    region: 'Africa',
    countryName: 'Gabon',
    transferMate: 84,
    nationality: 'Gabonese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GABON,
  },
  GAMBIA: {
    key: 'GAMBIA',
    region: 'Africa',
    countryName: 'Gambia',
    transferMate: 85,
    nationality: 'Gambian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GAMBIA,
  },
  GEORGIA: {
    key: 'GEORGIA',
    region: 'Non_EU Europe',
    countryName: 'Georgia',
    transferMate: 86,
    nationality: 'Georgian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GEORGIA,
  },
  GHANA: {
    key: 'GHANA',
    region: 'Africa',
    countryName: 'Ghana',
    transferMate: 89,
    nationality: 'Ghanaian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GHANA,
  },
  GIBRALTAR: {
    key: 'GIBRALTAR',
    region: 'Europe',
    countryName: 'Gibraltar',
    transferMate: 90,
    nationality: 'Gibraltarian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GIBRALTAR,
  },
  GREENLAND: {
    key: 'GREENLAND',
    region: 'Europe',
    countryName: 'Greenland',
    transferMate: 92,
    nationality: 'Greenlander',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GREENLAND,
  },
  GRENADA: {
    key: 'GRENADA',
    region: 'North America',
    countryName: 'Grenada',
    transferMate: 93,
    nationality: 'Grenadian',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GRENADA,
  },
  GUADELOUPE: {
    key: 'GUADELOUPE',
    region: 'North America',
    countryName: 'Guadeloupe',
    transferMate: 94,
    nationality: 'Guadeloupean',
    atas: false,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUADELOUPE,
  },
  GUAM: {
    key: 'GUAM',
    region: 'East Asia',
    countryName: 'Guam',
    transferMate: 95,
    nationality: 'Guamanian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUAM,
  },
  GUATEMALA: {
    key: 'GUATEMALA',
    region: 'North America',
    countryName: 'Guatemala',
    transferMate: 96,
    nationality: 'Guatemalan',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUATEMALA,
  },
  GUINEA: {
    key: 'GUINEA',
    region: 'Africa',
    countryName: 'Guinea',
    transferMate: 97,
    nationality: 'Guinean',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUINEA,
  },
  GUINEA_BISSAU: {
    key: 'GUINEA_BISSAU',
    region: 'Africa',
    countryName: 'Guinea-Bissau',
    transferMate: 98,
    nationality: 'Guinean (Bissau)',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUINEA_BISSAU,
  },
  GUYANA: {
    key: 'GUYANA',
    region: 'South America',
    countryName: 'Guyana',
    transferMate: 99,
    nationality: 'Guyanese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUYANA,
  },
  HAITI: {
    key: 'HAITI',
    region: 'North America',
    countryName: 'Haiti',
    transferMate: 100,
    nationality: 'Haitian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.HAITI,
  },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: {
    key: 'HEARD_ISLAND_AND_MCDONALD_ISLANDS',
    region: 'Oceania',
    countryName: 'Heard Island and Mcdonald Islands',
    nationality: 'Heard Island and Mcdonald Island',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  },
  VATICAN: {
    key: 'VATICAN',
    region: 'Europe',
    countryName: 'Vatican',
    nationality: 'Vatican',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.VATICAN,
  },
  HONDURAS: {
    key: 'HONDURAS',
    region: 'North America',
    countryName: 'Honduras',
    transferMate: 104,
    nationality: 'Honduran',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.HONDURAS,
  },
  INDIA: {
    key: 'INDIA',
    region: 'South Asia',
    countryName: 'India',
    transferMate: 109,
    nationality: 'Indian',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.INDIA,
  },
  IRAN_ISLAMIC_REPUBLIC_OF: {
    key: 'IRAN_ISLAMIC_REPUBLIC_OF',
    region: 'Middle East',
    countryName: 'Iran, Islamic Republic of',
    nationality: 'Iranian',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.IRAN_ISLAMIC_REPUBLIC_OF,
  },
  IRAQ: {
    key: 'IRAQ',
    region: 'Middle East',
    countryName: 'Iraq',
    transferMate: 112,
    nationality: 'Iraqi',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.IRAQ,
  },
  ISRAEL: {
    key: 'ISRAEL',
    region: 'Middle East',
    countryName: 'Israel',
    transferMate: 115,
    nationality: 'Israeli',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ISRAEL,
  },
  JAMAICA: {
    key: 'JAMAICA',
    region: 'North America',
    countryName: 'Jamaica',
    transferMate: 118,
    nationality: 'Jamaican',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.JAMAICA,
  },
  JORDAN: {
    key: 'JORDAN',
    region: 'Middle East',
    countryName: 'Jordan',
    transferMate: 121,
    nationality: 'Jordanian',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.JORDAN,
  },
  KENYA: {
    key: 'KENYA',
    region: 'Africa',
    countryName: 'Kenya',
    transferMate: 123,
    nationality: 'Kenyan',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.KENYA,
  },
  KIRIBATI: {
    key: 'KIRIBATI',
    region: 'Oceania',
    countryName: 'Kiribati',
    transferMate: 124,
    nationality: 'I_Kiribati',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.KIRIBATI,
  },
  NORTH_KOREA: {
    key: 'NORTH_KOREA',
    region: 'East Asia',
    countryName: 'North Korea',
    nationality: 'North Korean',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NORTH_KOREA,
  },
  KYRGYZSTAN: {
    key: 'KYRGYZSTAN',
    region: 'Central Asia (CIS)',
    countryName: 'Kyrgyzstan',
    transferMate: 127,
    nationality: 'Kyrgyzstani',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.KYRGYZSTAN,
  },
  LAOS: {
    key: 'LAOS',
    region: 'Southeast Asia',
    countryName: 'Laos',
    transferMate: 128,
    nationality: 'Laotian',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.LAOS,
  },
  LEBANON: {
    key: 'LEBANON',
    region: 'Middle East',
    countryName: 'Lebanon',
    transferMate: 130,
    nationality: 'Lebanese',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.LEBANON,
  },
  LESOTHO: {
    key: 'LESOTHO',
    region: 'Africa',
    countryName: 'Lesotho',
    transferMate: 131,
    nationality: 'Mosotho',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.LESOTHO,
  },
  LIBERIA: {
    key: 'LIBERIA',
    region: 'Africa',
    countryName: 'Liberia',
    transferMate: 132,
    nationality: 'Liberian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.LIBERIA,
  },
  LIBYA: {
    key: 'LIBYA',
    region: 'Africa',
    countryName: 'Libya',
    nationality: 'Libyan',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.LIBYA,
  },
  MADAGASCAR: {
    key: 'MADAGASCAR',
    region: 'Africa',
    countryName: 'Madagascar',
    transferMate: 139,
    nationality: 'Malagasy',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MADAGASCAR,
  },
  MALAWI: {
    key: 'MALAWI',
    region: 'Africa',
    countryName: 'Malawi',
    transferMate: 140,
    nationality: 'Malawian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MALAWI,
  },
  MALDIVES: {
    key: 'MALDIVES',
    region: 'South Asia',
    countryName: 'Maldives',
    transferMate: 142,
    nationality: 'Maldivan',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MALDIVES,
  },
  MALI: {
    key: 'MALI',
    region: 'Africa',
    countryName: 'Mali',
    transferMate: 143,
    nationality: 'Malian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MALI,
  },
  MARSHALL_ISLANDS: {
    key: 'MARSHALL_ISLANDS',
    region: 'Oceania',
    countryName: 'Marshall Islands',
    transferMate: 146,
    nationality: 'Marshallese',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MARSHALL_ISLANDS,
  },
  MARTINIQUE: {
    key: 'MARTINIQUE',
    region: 'North America',
    countryName: 'Martinique',
    transferMate: 147,
    nationality: 'Martinican',
    atas: false,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MARTINIQUE,
  },
  MAURITANIA: {
    key: 'MAURITANIA',
    region: 'Africa',
    countryName: 'Mauritania',
    transferMate: 148,
    nationality: 'Mauritanian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MAURITANIA,
  },
  MAYOTTE: {
    key: 'MAYOTTE',
    region: 'Africa',
    countryName: 'Mayotte',
    transferMate: 150,
    nationality: 'Mahoran',
    atas: false,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MAYOTTE,
  },
  MICRONESIA_FEDERATED_STATES_OF: {
    key: 'MICRONESIA_FEDERATED_STATES_OF',
    region: 'Oceania',
    countryName: 'Micronesia, Federated States of',
    nationality: 'Micronesian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MICRONESIA_FEDERATED_STATES_OF,
  },
  MOLDOVA_REPUBLIC_OF: {
    key: 'MOLDOVA_REPUBLIC_OF',
    region: 'Non_EU Europe|Central Asia (CIS)',
    countryName: 'Moldova, Republic of',
    nationality: 'Moldovan',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MOLDOVA_REPUBLIC_OF,
  },
  MONACO: {
    key: 'MONACO',
    region: 'Europe',
    countryName: 'Monaco',
    transferMate: 154,
    nationality: 'Monacan',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MONACO,
  },
  MONGOLIA: {
    key: 'MONGOLIA',
    region: 'East Asia',
    countryName: 'Mongolia',
    transferMate: 155,
    nationality: 'Mongolian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MONGOLIA,
  },
  MONTSERRAT: {
    key: 'MONTSERRAT',
    region: 'North America',
    countryName: 'Montserrat',
    transferMate: 156,
    nationality: 'Montserratian',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MONTSERRAT,
  },
  MOROCCO: {
    key: 'MOROCCO',
    region: 'Africa',
    countryName: 'Morocco',
    transferMate: 157,
    nationality: 'Moroccan',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MOROCCO,
  },
  MOZAMBIQUE: {
    key: 'MOZAMBIQUE',
    region: 'Africa',
    countryName: 'Mozambique',
    transferMate: 158,
    nationality: 'Mozambican',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MOZAMBIQUE,
  },
  MYANMAR: {
    key: 'MYANMAR',
    region: 'Southeast Asia',
    countryName: 'Myanmar',
    transferMate: 159,
    nationality: 'Myanmarese',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MYANMAR,
  },
  NAMIBIA: {
    key: 'NAMIBIA',
    region: 'Africa',
    countryName: 'Namibia',
    transferMate: 160,
    nationality: 'Namibian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NAMIBIA,
  },
  NAURU: {
    key: 'NAURU',
    region: 'Oceania',
    countryName: 'Nauru',
    transferMate: 161,
    nationality: 'Nauruan',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NAURU,
  },
  NEPAL: {
    key: 'NEPAL',
    region: 'South Asia',
    countryName: 'Nepal',
    transferMate: 162,
    nationality: 'Nepalese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NEPAL,
  },
  NEW_CALEDONIA: {
    key: 'NEW_CALEDONIA',
    region: 'Oceania',
    countryName: 'New Caledonia',
    transferMate: 262,
    nationality: 'New Caledonian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NEW_CALEDONIA,
  },
  NICARAGUA: {
    key: 'NICARAGUA',
    region: 'North America',
    countryName: 'Nicaragua',
    transferMate: 165,
    nationality: 'Nicaraguan',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NICARAGUA,
  },
  NIGER: {
    key: 'NIGER',
    region: 'Africa',
    countryName: 'Niger',
    transferMate: 166,
    nationality: 'Nigerien',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NIGER,
  },
  NIGERIA: {
    key: 'NIGERIA',
    region: 'Africa',
    countryName: 'Nigeria',
    transferMate: 167,
    nationality: 'Nigerian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NIGERIA,
  },
  NIUE: {
    key: 'NIUE',
    region: 'Oceania',
    countryName: 'Niue',
    transferMate: 168,
    nationality: 'Niuean',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NIUE,
  },
  NORFOLK_ISLAND: {
    key: 'NORFOLK_ISLAND',
    region: 'Oceania',
    countryName: 'Norfolk Island',
    transferMate: 169,
    nationality: 'Norfolk Islander',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NORFOLK_ISLAND,
  },
  NORTH_MACEDONIA_REPUBLIC_OF: {
    key: 'NORTH_MACEDONIA_REPUBLIC_OF',
    region: 'Non_EU Europe',
    countryName: 'North Macedonia, Republic of',
    nationality: 'Macedonian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NORTH_MACEDONIA_REPUBLIC_OF,
  },
  NORTHERN_MARIANA_ISLANDS: {
    key: 'NORTHERN_MARIANA_ISLANDS',
    region: 'Oceania',
    countryName: 'Northern Mariana Islands',
    transferMate: 170,
    nationality: 'Northern Mariana Islander',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.NORTHERN_MARIANA_ISLANDS,
  },
  PAKISTAN: {
    key: 'PAKISTAN',
    region: 'South Asia',
    countryName: 'Pakistan',
    transferMate: 173,
    nationality: 'Pakistani',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PAKISTAN,
  },
  PALAU: {
    key: 'PALAU',
    region: 'Oceania',
    countryName: 'Palau',
    transferMate: 174,
    nationality: 'Palauan',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PALAU,
  },
  PALESTINE: {
    key: 'PALESTINE',
    region: 'Middle East',
    countryName: 'Palestine',
    nationality: 'Palestinian',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PALESTINE,
  },
  PANAMA: {
    key: 'PANAMA',
    region: 'North America',
    countryName: 'Panama',
    transferMate: 175,
    nationality: 'Panamanian',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PANAMA,
  },
  PAPUA_NEW_GUINEA: {
    key: 'PAPUA_NEW_GUINEA',
    region: 'Oceania',
    countryName: 'Papua New Guinea',
    nationality: 'Papua New Guinean',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PAPUA_NEW_GUINEA,
  },
  PARAGUAY: {
    key: 'PARAGUAY',
    region: 'South America',
    countryName: 'Paraguay',
    transferMate: 177,
    nationality: 'Paraguayan',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PARAGUAY,
  },
  PHILIPPINES: {
    key: 'PHILIPPINES',
    region: 'Southeast Asia',
    countryName: 'Philippines',
    transferMate: 179,
    nationality: 'Filipino',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PHILIPPINES,
  },
  PITCAIRN: {
    key: 'PITCAIRN',
    region: 'Oceania',
    countryName: 'Pitcairn',
    nationality: 'Pitcairn Islander',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PITCAIRN,
  },
  PUERTO_RICO: {
    key: 'PUERTO_RICO',
    region: 'North America',
    countryName: 'Puerto Rico',
    transferMate: 183,
    nationality: 'Puerto Rican',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.PUERTO_RICO,
  },
  REUNION: {
    key: 'REUNION',
    region: 'South Asia',
    countryName: 'Reunion',
    transferMate: 185,
    nationality: 'Reunion',
    atas: false,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.REUNION,
  },
  RUSSIA: {
    key: 'RUSSIA',
    region: 'Non_EU Europe|Central Asia (CIS)',
    countryName: 'Russia',
    transferMate: 187,
    nationality: 'Russian',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.RUSSIA,
  },
  RWANDA: {
    key: 'RWANDA',
    region: 'Africa',
    countryName: 'Rwanda',
    transferMate: 188,
    nationality: 'Rwandan',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.RWANDA,
  },
  SAINT_HELENA: {
    key: 'SAINT_HELENA',
    region: 'Africa',
    countryName: 'Saint Helena',
    transferMate: 190,
    nationality: 'Saint Helenian',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_HELENA,
  },
  SAINT_KITTS_AND_NEVIS: {
    key: 'SAINT_KITTS_AND_NEVIS',
    region: 'North America',
    countryName: 'Saint Kitts and Nevis',
    nationality: 'Kittian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_KITTS_AND_NEVIS,
  },
  SAINT_LUCIA: {
    key: 'SAINT_LUCIA',
    region: 'North America',
    countryName: 'Saint Lucia',
    transferMate: 192,
    nationality: 'Saint Lucian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_LUCIA,
  },
  SAINT_PIERRE_AND_MIQUELON: {
    key: 'SAINT_PIERRE_AND_MIQUELON',
    region: 'North America',
    countryName: 'Saint Pierre and Miquelon',
    transferMate: 193,
    nationality: 'Saint_Pierrais',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_PIERRE_AND_MIQUELON,
  },
  SAINT_VINCENT_AND_THE_GRENADINES: {
    key: 'SAINT_VINCENT_AND_THE_GRENADINES',
    region: 'North America',
    countryName: 'Saint Vincent and the Grenadines',
    nationality: 'Saint Vincentian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_VINCENT_AND_THE_GRENADINES,
  },
  SAMOA: {
    key: 'SAMOA',
    region: 'Oceania',
    countryName: 'Samoa',
    transferMate: 195,
    nationality: 'Samoan',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAMOA,
  },
  SAN_MARINO: {
    key: 'SAN_MARINO',
    region: 'Europe',
    countryName: 'San Marino',
    transferMate: 196,
    nationality: 'Sanmarinese',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAN_MARINO,
  },
  SAO_TOME_AND_PRINCIPE: {
    key: 'SAO_TOME_AND_PRINCIPE',
    region: 'Africa',
    countryName: 'Sao Tome and Principe',
    transferMate: 197,
    nationality: 'Sao Tomean',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAO_TOME_AND_PRINCIPE,
  },
  SAUDI_ARABIA: {
    key: 'SAUDI_ARABIA',
    region: 'Middle East',
    countryName: 'Saudi Arabia',
    transferMate: 198,
    nationality: 'Saudi Arabian',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAUDI_ARABIA,
  },
  SENEGAL: {
    key: 'SENEGAL',
    region: 'Africa',
    countryName: 'Senegal',
    transferMate: 199,
    nationality: 'Senegalese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SENEGAL,
  },
  SEYCHELLES: {
    key: 'SEYCHELLES',
    region: 'Africa',
    countryName: 'Seychelles',
    transferMate: 201,
    nationality: 'Seychellois',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SEYCHELLES,
  },
  SIERRA_LEONE: {
    key: 'SIERRA_LEONE',
    region: 'Africa',
    countryName: 'Sierra Leone',
    transferMate: 202,
    nationality: 'Sierra Leonean',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SIERRA_LEONE,
  },
  SOLOMON_ISLANDS: {
    key: 'SOLOMON_ISLANDS',
    region: 'Oceania',
    countryName: 'Solomon Islands',
    transferMate: 206,
    nationality: 'Solomon Islander',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SOLOMON_ISLANDS,
  },
  SOMALIA: {
    key: 'SOMALIA',
    region: 'Africa',
    countryName: 'Somalia',
    transferMate: 207,
    nationality: 'Somali',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SOMALIA,
  },
  SOUTH_AFRICA: {
    key: 'SOUTH_AFRICA',
    region: 'Africa',
    countryName: 'South Africa',
    transferMate: 208,
    nationality: 'South African',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SOUTH_AFRICA,
  },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: {
    key: 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS',
    region: 'Central Asia (CIS)',
    countryName: 'South Georgia and the South Sandwich Islands',
    nationality: 'South Georgia and the South Sandwich Islands',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  },
  SRI_LANKA: {
    key: 'SRI_LANKA',
    region: 'South Asia',
    countryName: 'Sri Lanka',
    transferMate: 212,
    nationality: 'Sri Lankan',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SRI_LANKA,
  },
  SUDAN: {
    key: 'SUDAN',
    region: 'Africa',
    countryName: 'Sudan',
    transferMate: 213,
    nationality: 'Sudanese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SUDAN,
  },
  SURINAME: {
    key: 'SURINAME',
    region: 'South America',
    countryName: 'Suriname',
    transferMate: 214,
    nationality: 'Surinamer',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SURINAME,
  },
  SVALBARD_AND_JAN_MAYEN: {
    key: 'SVALBARD_AND_JAN_MAYEN',
    region: 'Europe',
    countryName: 'Svalbard and Jan Mayen',
    nationality: 'Svalbard and Jan Mayen',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SVALBARD_AND_JAN_MAYEN,
  },
  SWAZILAND: {
    key: 'SWAZILAND',
    region: 'Africa',
    countryName: 'Swaziland',
    transferMate: 216,
    nationality: 'Swazi',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SWAZILAND,
  },
  SYRIA: {
    key: 'SYRIA',
    region: 'Middle East',
    countryName: 'Syria',
    nationality: 'Syrian',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SYRIA,
  },
  TAJIKISTAN: {
    key: 'TAJIKISTAN',
    region: 'Central Asia (CIS)',
    countryName: 'Tajikistan',
    transferMate: 221,
    nationality: 'Tajikistani',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TAJIKISTAN,
  },
  TANZANIA_UNITED_REPUBLIC_OF: {
    key: 'TANZANIA_UNITED_REPUBLIC_OF',
    region: 'Africa',
    countryName: 'Tanzania, United Republic of',
    nationality: 'Tanzanian',
    atas: true,
    tb: true,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TANZANIA_UNITED_REPUBLIC_OF,
  },
  TIMOR_LESTE: {
    key: 'TIMOR_LESTE',
    region: 'Southeast Asia',
    countryName: 'Timor-Leste',
    nationality: 'Timorese',
    atas: true,
    tb: true,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TIMOR_LESTE,
  },
  TOGO: {
    key: 'TOGO',
    region: 'Africa',
    countryName: 'Togo',
    transferMate: 224,
    nationality: 'Togolese',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TOGO,
  },
  TOKELAU: {
    key: 'TOKELAU',
    region: 'Oceania',
    countryName: 'Tokelau',
    transferMate: 225,
    nationality: 'Tokelauan',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TOKELAU,
  },
  TONGA: {
    key: 'TONGA',
    region: 'Oceania',
    countryName: 'Tonga',
    transferMate: 226,
    nationality: 'Tongan',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TONGA,
  },
  TRINIDAD_AND_TOBAGO: {
    key: 'TRINIDAD_AND_TOBAGO',
    region: 'North America',
    countryName: 'Trinidad and Tobago',
    nationality: 'Trinidadian',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TRINIDAD_AND_TOBAGO,
  },
  TURKEY: {
    key: 'TURKEY',
    region: 'Non_EU Europe',
    countryName: 'Turkey',
    transferMate: 229,
    nationality: 'Turkish',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TURKEY,
  },
  TURKMENISTAN: {
    key: 'TURKMENISTAN',
    region: 'Central Asia (CIS)',
    countryName: 'Turkmenistan',
    transferMate: 230,
    nationality: 'Turkmen',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TURKMENISTAN,
  },
  TURKS_AND_CAICOS_ISLANDS: {
    key: 'TURKS_AND_CAICOS_ISLANDS',
    region: 'North America',
    countryName: 'Turks and Caicos Islands',
    nationality: 'Turks and Caicos Islander',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TURKS_AND_CAICOS_ISLANDS,
  },
  TUVALU: {
    key: 'TUVALU',
    region: 'Oceania',
    countryName: 'Tuvalu',
    transferMate: 232,
    nationality: 'Tuvaluan',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.TUVALU,
  },
  UGANDA: {
    key: 'UGANDA',
    region: 'Africa',
    countryName: 'Uganda',
    transferMate: 233,
    nationality: 'Ugandan',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.UGANDA,
  },
  UKRAINE: {
    key: 'UKRAINE',
    region: 'Non_EU Europe',
    countryName: 'Ukraine',
    transferMate: 234,
    nationality: 'Ukrainian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.UKRAINE,
  },
  UNITED_KINGDOM: {
    key: 'UNITED_KINGDOM',
    region: 'UK',
    countryName: 'United Kingdom',
    transferMate: 236,
    nationality: 'British',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.UNITED_KINGDOM,
  },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: {
    key: 'UNITED_STATES_MINOR_OUTLYING_ISLANDS',
    region: 'Oceania',
    countryName: 'United States Minor Outlying Islands',
    nationality: 'American (MOI)',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  },
  URUGUAY: {
    key: 'URUGUAY',
    region: 'South America',
    countryName: 'Uruguay',
    transferMate: 239,
    nationality: 'Uruguayan',
    atas: true,
    tb: false,
    riskLevel: 1,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.URUGUAY,
  },
  UZBEKISTAN: {
    key: 'UZBEKISTAN',
    region: 'Central Asia (CIS)',
    countryName: 'Uzbekistan',
    transferMate: 241,
    nationality: 'Uzbekistani',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.UZBEKISTAN,
  },
  VANUATU: {
    key: 'VANUATU',
    region: 'Oceania',
    countryName: 'Vanuatu',
    transferMate: 242,
    nationality: 'Ni_Vanuatu',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.VANUATU,
  },
  VENEZUELA: {
    key: 'VENEZUELA',
    region: 'South America',
    countryName: 'Venezuela',
    transferMate: 244,
    nationality: 'Venezuelan',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.VENEZUELA,
  },
  VIETNAM: {
    key: 'VIETNAM',
    region: 'Southeast Asia',
    countryName: 'Vietnam',
    transferMate: 245,
    nationality: 'Vietnamese',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.VIETNAM,
  },
  VIRGIN_ISLANDS_BRITISH: {
    key: 'VIRGIN_ISLANDS_BRITISH',
    region: 'North America',
    countryName: 'Virgin Islands, British',
    nationality: 'Virgin Islander (British)',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.VIRGIN_ISLANDS_BRITISH,
  },
  VIRGIN_ISLANDS_US: {
    key: 'VIRGIN_ISLANDS_US',
    region: 'North America',
    countryName: 'Virgin Islands, U.S.',
    nationality: 'Virgin Islander (American)',
    atas: true,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.VIRGIN_ISLANDS_US,
  },
  WALLIS_AND_FUTUNA: {
    key: 'WALLIS_AND_FUTUNA',
    region: 'Oceania',
    countryName: 'Wallis and Futuna',
    nationality: 'Wallisian',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.WALLIS_AND_FUTUNA,
  },
  WESTERN_SAHARA: {
    key: 'WESTERN_SAHARA',
    region: 'Africa',
    countryName: 'Western Sahara',
    transferMate: 266,
    nationality: 'Western Saharan',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.WESTERN_SAHARA,
  },
  YEMEN: {
    key: 'YEMEN',
    region: 'Middle East',
    countryName: 'Yemen',
    transferMate: 249,
    nationality: 'Yemenese',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.YEMEN,
  },
  ZAMBIA: {
    key: 'ZAMBIA',
    region: 'Africa',
    countryName: 'Zambia',
    transferMate: 250,
    nationality: 'Zambian',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ZAMBIA,
  },
  ZIMBABWE: {
    key: 'ZIMBABWE',
    region: 'Africa',
    countryName: 'Zimbabwe',
    transferMate: 251,
    nationality: 'Zimbabwean',
    atas: true,
    tb: true,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ZIMBABWE,
  },
  ALAND_ISLANDS: {
    key: 'ALAND_ISLANDS',
    region: 'Europe',
    countryName: 'Åland Islands',
    nationality: 'Ålandic',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ALAND_ISLANDS,
  },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: {
    key: 'BONAIRE_SINT_EUSTATIUS_AND_SABA',
    region: 'North America',
    countryName: 'Bonaire, Sint Eustatius and Saba',
    nationality: 'Dutch (Caribbean)',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA,
  },
  CURACAO: {
    key: 'CURACAO',
    region: 'North America',
    countryName: 'Curaçao',
    nationality: 'Curaçaoan',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.CURACAO,
  },
  GUERNSEY: {
    key: 'GUERNSEY',
    region: 'Europe',
    countryName: 'Guernsey',
    transferMate: 258,
    nationality: 'Guernsey',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.GUERNSEY,
  },
  ISLE_OF_MAN: {
    key: 'ISLE_OF_MAN',
    region: 'Europe',
    countryName: 'Isle of Man',
    transferMate: 259,
    nationality: 'Manx',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.ISLE_OF_MAN,
  },
  JERSEY: {
    key: 'JERSEY',
    region: 'Europe',
    countryName: 'Jersey',
    transferMate: 260,
    nationality: 'Jersey',
    atas: false,
    tb: false,
    riskLevel: 0,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.JERSEY,
  },
  MONTENEGRO: {
    key: 'MONTENEGRO',
    region: 'Non_EU Europe',
    countryName: 'Montenegro',
    nationality: 'Montenegrin',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.MONTENEGRO,
  },
  SAINT_BARTHELEMY: {
    key: 'SAINT_BARTHELEMY',
    region: 'North America',
    countryName: 'Saint Barthélemy',
    nationality: 'Barthélemois',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_BARTHELEMY,
  },
  SAINT_MARTIN_FRANCE: {
    key: 'SAINT_MARTIN_FRANCE',
    region: 'North America',
    countryName: 'Saint Martin (France)',
    nationality: 'French (Saint Martin)',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SAINT_MARTIN_FRANCE,
  },
  SINT_MAARTEN_DUTCH: {
    key: 'SINT_MAARTEN_DUTCH',
    region: 'North America',
    countryName: 'Sint Maarten (Dutch)',
    nationality: 'Dutch (St. Martin)',
    atas: true,
    tb: false,
    riskLevel: 2,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SINT_MAARTEN_DUTCH,
  },
  SOUTH_SUDAN: {
    key: 'SOUTH_SUDAN',
    region: 'Africa',
    countryName: 'South Sudan',
    nationality: 'Sudanese (South)',
    atas: true,
    tb: true,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.SOUTH_SUDAN,
  },
  KOSOVO: {
    key: 'KOSOVO',
    region: 'Non_EU Europe',
    countryName: 'Kosovo',
    nationality: 'Kosovian',
    atas: true,
    tb: false,
    riskLevel: 3,
    category: 'NonAppendixH',
    categoryNewNameRefactor: 'Standard',
    ...countryCodes.KOSOVO,
  },
};
